
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 3840 2160","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1377.97 1095.84c-12.45-15.56-13.49-32.16-3.12-49.8 8.3-17.63 22.31-26.45 42.02-26.45h236.53V387.796c0-14.524 4.67-26.454 14.01-35.791 9.34-9.337 20.75-14.005 34.23-14.005h435.72c13.49 0 24.9 4.668 34.24 14.005 9.33 9.337 14 21.267 14 35.791v631.794h236.54c19.71 0 33.71 8.82 42.01 26.45 10.37 17.64 9.34 34.24-3.12 49.8l-501.07 704.93c-8.3 13.49-21.26 20.23-38.91 20.23-17.63 0-30.6-6.74-38.9-20.23l-504.18-704.93z","fill":"#FA507B"}})])
          )
        }
      }
    